import { render, staticRenderFns } from "./PEC.vue?vue&type=template&id=357cf334&scoped=true"
import script from "./PEC.vue?vue&type=script&lang=js"
export * from "./PEC.vue?vue&type=script&lang=js"
import style0 from "./PEC.vue?vue&type=style&index=0&id=357cf334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357cf334",
  null
  
)

export default component.exports